import { Component, OnDestroy, OnInit, OnChanges, EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import {Location} from '@angular/common';
import { UserFull } from '../../../../shared/models/userFull.model';

import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
 import {Observable, Subject} from 'rxjs';


// Notifications

import { DatePipe } from '@angular/common';
import { FileUploadsModalComponent } from './../../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UserAvitarModalUploadComponent} from './../../../../admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { ColorPickerComponent, OpenEventArgs } from '@syncfusion/ej2-angular-inputs';
import { SystemAutomation } from 'src/app/shared/models/systemAutomation.model';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { SystemLogType } from 'src/app/shared/models/systemLogType.model';
import { BenchmarkKpiGroup } from 'src/app/shared/models/benchmarkKpiGroup.model';







@Component({
  selector: 'app-benchmarkpi-group-update',
  templateUrl: './benchmarkpi-group-update.component.html',
  styleUrls: ['./benchmarkpi-group-update.component.scss']
})
export class BenchmarkpiGroupUpdateComponent implements OnInit {


 // setup as observable?
 @Input() item_id?; // impliments on changes.
 @Input() item_data?; // if data.model is sent ;
 @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
 @Input() item_user_level_id? = '5'; // default to agent just in case
 @Input() item_brand_type_id? = '';
 @Input() show_buttons? = 'no'; // yes | no
 @Input() widget_title? = '';
 @Input() widget_size? = 'full'; // side | abstract | full | update_password

 allRecipients = [];
//  allAutomtaions = [];
allAutomations = [];
allLogTypesArray = [];

  // user_id: number;
  brand_user_update: any;
  user_levels: any;
  brands: any;

  @ViewChild('UserForm') form: any;
  updateBrandUserClick;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  brand_types: any;
  brand: any;
  @Input() user_id: number;
  stripped: any;
  filenameselected: any;
  baseUploadURL: string;
  log_type_id: any;
  system_log_type: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
 //Slider
  slidervalue: string;
  ticks: { placement: string; largeStep: number; smallStep: number; showSmallTicks: boolean; };
  public data_sector_fields: Object = { text: 'log_type_data_sector_name', value: 'log_type_data_sector_id', icon: 'log_type_data_sector_icon', colour: 'log_type_data_sector_colour', is_active: 'is_active', description: 'log_type_data_sector_description'}; // using the name field not id!

  isShow_log_insert_template = false;


public cValue: string = "#1de4d7";
  system_log_type_data_sectors: any;
@Input('UserForm') UserForm: any;
  system_log_levels: any;
  model: BenchmarkKpiGroup;
  system_log_type_automations: any;
  benchmark_kpi_group_id: number;
  benchmark_kpi_group: any;
  benchmark_kpi_group_log_type_array: any;
  system_log_types: any;
@Input('value')
    set value(value: any) {
        this.cValue = value;
    }


    // Combo List Boxes
    public groupA: { [key: string]: Object }[] = [
      { "Name": "Australia", "Code": "AU" },
      { "Name": "Bermuda", "Code": "BM" },
      { "Name": "Canada", "Code": "CA" },
      { "Name": "Cameroon", "Code": "CM" },
      { "Name": "Denmark", "Code": "DK" },
      { "Name": "France", "Code": "FR" },
      { "Name": "Finland", "Code": "FI" },
      { "Name": "Germany", "Code": "DE" },
      { "Name": "Hong Kong", "Code": "HK" }
  ];
  
  public groupB: { [key: string]: Object }[] = [
      { "Name": "India", "Code": "IN" },
      { "Name": "Italy", "Code": "IT" },
      { "Name": "Japan", "Code": "JP" },
      { "Name": "Mexico", "Code": "MX" },
      { "Name": "Norway", "Code": "NO" },
      { "Name": "Poland", "Code": "PL" },
      { "Name": "Switzerland", "Code": "CH" },
      { "Name": "United Kingdom", "Code": "GB" },
      { "Name": "United States", "Code": "US" }
  ];
  public setfield = { text: "Name" }
  public toolbar = { items: ['moveUp', 'moveDown', 'moveTo', 'moveFrom', 'moveAllTo', 'moveAllFrom'] }
    
  // public system_log_types: Array<{ log_type_id: number, log_type_name: string }> = [];
  public log_types_array: Array<{ log_type_id: number, log_type_name: string }> = [];

  public availableLogTypes: any[] = [];
  public selectedLogTypes: any[] = [];

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router:Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _location: Location,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
  ) { 


      // login vars
  this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
  console.log('sessionUserId: ', this.currentUserVAR.user_id );
  console.log('sessionUsername: ', this.currentUserVAR.username );
  // Set loggind in User Value (USER ID)
  this.sessionUserId = this.currentUserVAR.user_id;
  this.sessionUserName = this.currentUserVAR.username;
  this.sessionBrandId = this.currentUserVAR.brand_id;

  this.benchmark_kpi_group_id = +this.route.snapshot.paramMap.get('benchmark_kpi_group_id');


  this.slidervalue = "30";
this.ticks = {
    placement: 'Before',
    largeStep: 20,
    smallStep: 5,
    showSmallTicks: true
  };

   }




 // check for changes. to load data.
 ngOnChanges(changes) {
  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.benchmark_kpi_group_id = changes.item_id.currentValue;
   //  this.getBrandById(this.brand_id);
  //  this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash


  this.model = new BenchmarkKpiGroup();
  // this.getSystemLogType(this.log_type_id)
  this.getBenchmarkKpiGroup(this.benchmark_kpi_group_id)
  this.getSystemLogTypes();
  
  // this.getSystemLogTypeDataSectors();
  // this.getSystemLogLevels();

    // this.getBrandUser(this.gfunc.sessionUserId);
    // this.getFormUserLevels();
    // this.getBrands();
  }
}



  ngOnInit() {
    this.model = new BenchmarkKpiGroup();

 // Set the model.?
//  this.getSystemLogType(this.log_type_id)

this.getBenchmarkKpiGroup(this.benchmark_kpi_group_id)

//  this.getSystemLogTypeDataSectors();
//  this.getSystemLogLevels();
  }


setColour(value2){
  console.log('SetColour: ' + value2)
  this.UserForm.log_type_colour.value = this.UserForm.colourpicker.value
}


   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      user_id: this.user_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UserAvitarModalUploadComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.user_id = this.user_id;
   // this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.user_id;
    this.bsModalRef.content.closeBtnName = 'Close';


  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_P.bind(this)); /// THIS WORKLED // when clicked.....

   }

// :: Parent / Child modal test
public addFileNameFromModal_P(filename) {

  // this.model.logo = filename;
  this.form.controls['photo'].patchValue(filename); // works by setting the new frorm value from parent modal.

// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};

 
// Database Functions
getBrandUser(user_id) {
  this._demoService.getBrandUser(user_id).subscribe(
     data => { this.brand_user_update = data;
    
    },
     err => console.error(err),
     () => console.log('done loading user for update')
   );
 }



 getBenchmarkKpiGroup(benchmark_kpi_group_id) {
  this._demoService.getBenchmarkKpiGroup(benchmark_kpi_group_id).subscribe(
     data => { this.benchmark_kpi_group = data;

      let res = data[0]
      // this.allRecipients = JSON.parse(this.system_log_type[0].system_automation_array);
      this.allLogTypesArray = JSON.parse(this.benchmark_kpi_group[0].log_types_array);
      // // Lookup the Automations

      let new_model = {
        log_types_array: JSON.parse(this.benchmark_kpi_group[0].log_types_array)
      }
      // this.getSystemAutomationsArray(new_model);

      this.getBenchmarkKpiGroupLogTypesArray(new_model)

    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


 getSystemLogTypeDataSectors() {
  this._demoService.getSystemLogTypeDataSectors().subscribe(
     data => { this.system_log_type_data_sectors = data;
    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }



  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



 getSystemLogLevels() {
  this._demoService.getSystemLogLevels().subscribe(
     data => { this.system_log_levels = data;
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


// update was here for onit but moved for onchange
updateBrandUser(model) {
this._demoService.updateBrandUser(model).subscribe(
   data => {
    console.log(model);
     // this.trace_candidate_update = data;
   this.toastr.success('User Updated');
   this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
   this.gfunc.globalUserView(model.user_id);
   // Subject to reload the manager component parent.
  // BrandUserManagerComponent.returned.next(false);
     return true;
   },
   error => {
     console.error('Error saving User!');
    return console.log(error);
   }
  // err => console.error(err),
  // () => console.log('done updates')
);
}

// update was here for onit but moved for onchange
// updateSystemLogType(model) {

//   // model.system_automation_array = this.allAutomtaions;

//         this._demoService.updateSystemLogType(model).subscribe(
//            data => {
//             console.log(model);
//              // this.trace_candidate_update = data;
//            this.toastr.success('Log Type Updated');
//           //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
//           //  this.gfunc.globalUserView(model.user_id);
//            // Subject to reload the manager component parent.
//           // BrandUserManagerComponent.returned.next(false);
//              return true;
//            },
//            error => {
//              console.error('Error saving Log Type!');
//             return console.log(error);
//            }
//           // err => console.error(err),
//           // () => console.log('done updates')
//         );
//   }





  updateBenchmarkKpiGroup(model) {

    // model.system_automation_array = this.allAutomtaions;
  
          this._demoService.updateSBenchmarkKpiGroup(model).subscribe(
             data => {
              console.log(model);
               // this.trace_candidate_update = data;
             this.toastr.success('Bencmark KP Group Updated');
            //  this.gfunc.insertLog_UpdateUser(model); // hadled in the global functions file.
            //  this.gfunc.globalUserView(model.user_id);
             // Subject to reload the manager component parent.
            // BrandUserManagerComponent.returned.next(false);
               return true;
             },
             error => {
               console.error('Error saving group!');
              return console.log(error);
             }
            // err => console.error(err),
            // () => console.log('done updates')
          );
    }
  


getFormUserLevels() {
  this._demoService.getFormUserLevels().subscribe(
     data2 => { this.user_levels = data2;
      console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }


 getBrands() {
  this._demoService.getBrands().subscribe(
     data2 => { this.brands = data2;
     // console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Brands')
   );
 }



 addRecipientFromModal(model, system_automation_id) {


this.allRecipients.push(
  system_automation_id
);

this.allRecipients = this.allRecipients;
// this.model.allRecipients = this.allRecipients;

// this.model.system_automation_array = this.allRecipients;

// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )


this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};




// addAutomationFromModal(model, system_automation_id) {
//   // alert('parent component function.');
//  // this.modalService.hide(1); - removed the scroll bard do not use!!!
//   // this.modalRef.hide();
//  // this.getJobPlaintiffs(this.job_id);
//  // this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// // :: reset the entire page.
// // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// // this.allRecipients.push({
// //   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
// //   recipient_email_address: model.recipient_email_address,
// //   recipient_brand_id: null,
// //   recipient_brand_type_id: null,
// //   recipient_user_id: null,
// //   recipient_user_level_id: null,
// //   recipient_type_name: model.recipient_type_name,
// //   model.system_automation_id,
// // });

// this.allAutomations.push(
//   system_automation_id
// );

// this.allAutomations = this.allAutomations;
// // this.model.system_automation_array = this.allAutomtaions;

// // simple small updated - quick and then refresh the page
// // this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// // this.model.log_type_id = this.log_type_id;

// this.form.controls['system_automation_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
// // rest the list
// let new_model = {
//   system_automation_array: this.allAutomations
// }
// this.getSystemAutomationsArray(new_model);


// // model.allRecipients = this.allRecipients;

// // this.model.system_automation_array.push(
// //   system_automation_id
// // )
// // this.model.system_automation_array = this.allAutomtaions;
// // this.updateSystemLogType(model);
// // this.getSystemLogType(this.log_type_id);

// this.modalRef.hide();
// // console.log('Added External Recipeint.');
// // this.toastr.info('External Recipient Added');
// };



addLogTypeFromModal(model, log_type_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allLogTypesArray.push(
  log_type_id
);

this.allLogTypesArray = this.allLogTypesArray;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['log_types_array'].patchValue(JSON.stringify(this.allLogTypesArray)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  log_types_array: this.allLogTypesArray
}
this.getBenchmarkKpiGroupLogTypesArray(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};


// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};



RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value === key) {
      this.allRecipients.splice(index, 1);
    }
  });

    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


RemoveElementFromAllAutomations(key: number) {
  if (confirm('Are you sure you wish to remove the automation from the triggered list?')) {

  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAutomations.forEach((value, index) => {
    if (value === key) {
      this.allAutomations.splice(index, 1);
    }
  });

      this.form.controls['system_automation_array'].patchValue(JSON.stringify(this.allAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_automation_array: this.allAutomations
      }
      this.getSystemAutomationsArray(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

  } // end confirm

};




RemoveElementFromAllLogTypesArray(key: number) {
  if (confirm('Are you sure you wish to remove the log type from the group?')) {

  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allLogTypesArray.forEach((value, index) => {
    if (value === key) {
      this.allLogTypesArray.splice(index, 1);
    }
  });

      this.form.controls['log_types_array'].patchValue(JSON.stringify(this.allLogTypesArray)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        log_types_array: this.allLogTypesArray
      }
      this.getBenchmarkKpiGroupLogTypesArray(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

  } // end confirm

};



getSystemAutomationsArray(request_array) {
  this._demoService.getSystemAutomationsArray(request_array).subscribe(
     data => { this.system_log_type_automations = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getBenchmarkKpiGroupLogTypesArray(request_array) {
  this._demoService.getBenchmarkKpiGroupLogTypesArray(request_array).subscribe(
     data => { 
      // this.system_log_type_automations = data;
      this.benchmark_kpi_group_log_type_array = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


// copy to clipbard button
// ::@ https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard
copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.success(val + '');
}


 // Fetches available log types from the API
 getSystemLogTypes() {
  this._demoService.getSystemLogTypes().subscribe(
    (data) => {
      this.system_log_types = data;
      // Populate availableLogTypes for the Dual ListBox
      this.availableLogTypes = this.system_log_types.map(log => ({
        id: log.log_type_id,
        name: log.log_type_name
      }));
    },
    (error) => console.error('Error loading log types:', error),
    () => console.log('Finished loading log types')
  );
}

// Updates selected log types array and the model log_types_array
onSelect(args: any): void {
  this.log_types_array = [...args];
}
}